export default "__VITE_ASSET__ff9742b9__"